import { Col, Row } from 'antd';
import { MFormSection, MSpinner, MyAccountLayout, MyAccountSidebarOtherMenuItemKey } from 'src/lib';
import { AccountStatusLabel } from 'src/models';
import { AccountApplicationForm } from 'src/pages/AccountApplication';
import { Spacing } from 'src/styles';

import { CurrentAccountStatus } from './CurrentAccountStatus';
import { CurrentAccountStatusDescription } from './CurrentAccountStatusDescription';

export const AccountApplicationContent = ({
  isLoading,
  status,
}: {
  isLoading: boolean;
  status: AccountStatusLabel;
}) => {
  if (isLoading) {
    return <MSpinner />;
  }

  return (
    <MyAccountLayout sidebarMenuItemKey={MyAccountSidebarOtherMenuItemKey.AccountStatus} title='Account Status'>
      <Row>
        <Col span={24}>
          <MFormSection
            title={<CurrentAccountStatus label={status} />}
            isEditable={false}
            isEditMode={false}
            className={Spacing.mt0}>
            <CurrentAccountStatusDescription />
            <AccountApplicationForm />
          </MFormSection>
        </Col>
      </Row>
    </MyAccountLayout>
  );
};
